var exports = {
  "k": "xe7b6e3d6--bdf989--container",
};

module.exports = exports;
